// client/src/pages/ShopPOS/types/index.ts

// ============ TIPOS DEL CARRITO ============
export interface CartItem {
  inventoryId: string;
  quantity: number;
  surchargePercentage?: number;
}

// ============ TIPOS DE TRANSFERENCIA ============
export interface TransferData {
  fullName: string;
  ci: string;
  phone: string;
  transferCode: string;
  bank: string;
  firstFourDigits: string;
  lastFourDigits: string;
  destinationCard: string;
}

export const DEFAULT_TRANSFER_DATA: TransferData = {
  fullName: "",
  ci: "",
  phone: "",
  transferCode: "",
  bank: "",
  firstFourDigits: "",
  lastFourDigits: "",
  destinationCard: "",
};

// ============ TIPOS DE CIERRE DE TURNO ============
export type CloseType = "day_close" | null;

// ============ TIPOS DE MÉTODO DE PAGO ============
export type PaymentMethod = "efectivo" | "transferencia" | "mixto";

// ============ TIPOS DE SINCRONIZACIÓN ============
export interface SyncProgress {
  current: number;
  total: number;
  isSyncing: boolean;
}

export const DEFAULT_SYNC_PROGRESS: SyncProgress = {
  current: 0,
  total: 0,
  isSyncing: false,
};

// ============ TIPOS DE VENTA OFFLINE ============
export interface OfflineSaleData {
  id: string;
  shopId: string;
  total: number;
  paymentMethod: string;
  items: OfflineSaleItem[];
  createdAt: string;
  shiftId?: string;
  customerId?: string;
  cashReceived?: number;
  changeGiven?: number;
  fullName?: string;
  ci?: string;
  phone?: string;
  transferCode?: string;
  bank?: string;
  firstFourDigits?: string;
  lastFourDigits?: string;
}

export interface OfflineSaleItem {
  productId: string;
  quantity: number;
  price: number;
  inventoryId: string;
  surchargePercentage: number;
}

// ============ TIPOS DE FILTROS ============
export interface InventoryFilters {
  page: number;
  limit: number;
  search: string;
  minPrice: number | "";
  maxPrice: number | "";
}

// ============ TIPOS DE TURNO ============
export interface ShiftSummary {
  initialCash: number;
  cashSales: number;
  transferSales: number;
  cardSales: number;
  totalSales: number;
  expectedCash: number;
  hasBeenCounted: boolean;
  openedAt: string;
  openedBy: string;
}
